export enum DOMAIN {
  FOOT_LOCKER = 'FOOT_LOCKER',
  NYKAA_FASHION = 'NYKAA_FASHION',
}

export const BRAND_NAME_FL = 'Foot Locker';
